import React, { useEffect } from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import './AccessoriesProducts.css';
import ProductModal from './ProductModal';
import ap1_1 from './assets/accessories/ap1_1.jpg';
import ap1_2 from './assets/accessories/ap1_2.jpg';
import ap3_1 from './assets/accessories/ap3_1.jpg';
import ap4_1 from './assets/accessories/ap4_1.jpg';
import ap4_2 from './assets/accessories/ap4_2.jpg';
import ap5_1 from './assets/accessories/ap5_1.jpg';
import img1840_1 from './assets/accessories/0M1A1840.jpg';
import img1840_2 from './assets/accessories/0M1A1846.jpg';
import img1840_3 from './assets/accessories/0M1A1847.jpg';
import img1998HR_1 from './assets/accessories/0M1A1998.jpg';
import img1998HR_2 from './assets/accessories/0M1A2002.jpg';
import img4267_1 from './assets/accessories/0M1A4267.jpg';
import img4267_2 from './assets/accessories/0M1A4272.jpg';
import img4267_3 from './assets/accessories/0M1A4273.jpg';
import img4267_4 from './assets/accessories/0M1A4274.jpg';
import img4292_1 from './assets/accessories/0M1A4292.jpg';
import img4292_2 from './assets/accessories/0M1A4293.jpg';
import img4292_3 from './assets/accessories/0M1A4295.jpg';
import img4292_4 from './assets/accessories/0M1A4296.jpg';
import img4499_1 from './assets/accessories/0M1A4499.jpg';
import img4499_2 from './assets/accessories/0M1A4500.jpg';
import img4499_3 from './assets/accessories/0M1A4502.jpg';
import img7788_1 from './assets/accessories/0M1A7788.jpg';
import img7790_1 from './assets/accessories/0M1A7790.jpg';
import img7790_2 from './assets/accessories/0M1A7791.jpg';
import img7790_3 from './assets/accessories/0M1A7794.jpg';
import img7815_1 from './assets/accessories/0M1A7815.jpg';
import img7815_2 from './assets/accessories/0M1A7817.jpg';
import img7815_3 from './assets/accessories/0M1A7818.jpg';
import imgRef38_1 from './assets/accessories/Ref 38 (1).jpg';
import imgRef38_2 from './assets/accessories/Ref 38 (2).JPG';
import imgWashPack_1 from './assets/accessories/Wash Leather Fold-over Backpack.jpg';
import imgWashPack_2 from './assets/accessories/Wash Leather Fold-over Backpack b.jpg';
import mp6_1 from './assets/accessories/mp6_1.jpg';
import mp7_1 from './assets/accessories/mp7_1.jpg';
import mp8_1 from './assets/accessories/mp8_1.jpg';
import mp8_2 from './assets/accessories/mp8_2.jpg';
import mp8_3 from './assets/accessories/mp8_3.jpg';

const AccessoriesProducts = () => {
  const [selectedProduct, setSelectedProduct] = React.useState(null);
  const [isModalOpen, setIsModalOpen] = React.useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const openProduct = (name, image) => {
    setSelectedProduct({ name, image, category: "ACCESSORIES" });
    setIsModalOpen(true);
  };

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
  };

  const createCard = (images, title) => (
    <div 
      className="card" 
      onClick={(e) => {
        if (e.target.closest('.slick-arrow') || e.target.closest('.slick-dots')) {
          return;
        }
        openProduct(title, images);
      }}
    >
      {images.length > 1 ? (
        <Slider {...settings}>
          {images.map((image, index) => (
            <div key={index}>
              <img src={image} alt={`${title} - ${index + 1}`} />
            </div>
          ))}
        </Slider>
      ) : (
        <div>
          <img src={images[0]} alt={`${title} - 1`} />
        </div>
      )}
      <h3>{title}</h3>
    </div>
  );

  return (
    <div className="category-container">
      <h2>Accessories</h2>
      <div className="card-container">
        {createCard([ap4_1, ap4_2], "1998")}
        {createCard([ap3_1], "1573")}
        {createCard([ap5_1], "L-13")}
        {createCard([ap1_1, ap1_2], "COGNAC 007")}
        {createCard([img1840_1, img1840_2, img1840_3], "Model 1840")}
        {createCard([img1998HR_1, img1998HR_2], "1998 High-Res")}
        {createCard([img4267_1, img4267_2, img4267_3, img4267_4], "Model 4267")}
        {createCard([img4292_1, img4292_2, img4292_3, img4292_4], "Model 4292")}
        {createCard([img4499_1, img4499_2, img4499_3], "Model 4499")}
        {createCard([img7788_1,img7790_1, img7790_2, img7790_3], "Model 7788")}
        {createCard([img7815_1, img7815_2, img7815_3], "Model 7815")}
        {createCard([imgRef38_1, imgRef38_2], "Ref 38")}
        {createCard([imgWashPack_1, imgWashPack_2], "Wash Leather Backpack")}
        {createCard([mp8_1, mp8_2, mp8_3], "AN 67")}
        {createCard([mp6_1], "AN 9551")}
        {createCard([mp7_1], "AN 907")}
      </div>
      <ProductModal 
        product={selectedProduct} 
        isOpen={isModalOpen} 
        onClose={() => setIsModalOpen(false)} 
      />
    </div>
  );
};

export default AccessoriesProducts;
